import { UserModel } from '@/models/UserHierarchy'
import _get from 'lodash/get'

export class MerchantModel extends UserModel {
  static entity = 'merchants'
  static baseEntity = 'users'

  static nameSingular = 'Merchant'
  static namePlural = 'Merchants'

  static fields() {
    return {
      ...super.fields(),
      stripe: this.attr(),
      is_merchant: this.boolean(true),
      is_super_admin: this.boolean(false),
      is_admin_drawer_mini: this.boolean(false),
    }
  }

  get stripe_id() {
    return _get(this, 'stripe.id')
  }
  get stripe_customer_id() {
    return _get(this, 'stripe.customer_id')
  }

  static resetPassword(shopId, token, email, password) {
    return this.api().post(`/shops/${shopId}/password/reset`, {
      token,
      email,
      password,
    })
  }
  static sendPasswordEmail(shopId, email) {
    return this.api().post(`/shops/${shopId}/password/email`, {
      email,
    })
  }
}

export default MerchantModel
